import type { PlaceholderData } from "@/components/lexical/placeholders"

import type { UpstreamActionInfo } from "./subject-scope"

/**
 * Converts a guid to the step context key format used by the backend.
 * Matches AutomationVariableInterpolator.step_context_key.
 */
function stepContextKey(guid: string): string {
  const sanitized = guid.toLowerCase().replace(/[^a-z0-9_]/g, "_")
  return `step_${sanitized}`
}

export function getStepResultPlaceholders(
  upstreamActions: UpstreamActionInfo[],
  includeSensitiveContent: boolean
): PlaceholderData[] {
  const placeholders: PlaceholderData[] = []

  for (const action of upstreamActions) {
    if (!includeSensitiveContent && action.isAiAction) continue
    const contextKey = stepContextKey(action.guid)
    const isResearch = action.nodeKey === "action__ai_research"
    const category = isResearch ? "Research" : action.label

    for (const [fieldKey, fieldInfo] of Object.entries(action.resultSchema)) {
      const fieldLabel = fieldInfo.description || fieldKey

      placeholders.push({
        id: `${contextKey}_${fieldKey}`,
        label: isResearch ? action.label : fieldLabel,
        value: `{{ ${contextKey}.${fieldKey} }}`,
        category,
      })
    }
  }

  return placeholders
}
